module.exports = __webpack_public_path__ + "static/usa-82f107981c523eb2ac3589fb1ba8f18a.jpg";